export const resolveGreetingName = (
  displayName: string | null | undefined,
): string | null => {
  if (!displayName) return null
  const trimmed = displayName.trim()
  return trimmed.length > 0 ? trimmed : null
}

export type ResolveGreetingName = typeof resolveGreetingName
